<template>
  <v-layout row wrap>
    <v-flex
      v-for="(interested) in interesteds"
      :key="interested.interested_id"
      xs4
    >
      <v-card class="elevation-1">
        <v-list-tile
          avatar
          ripple
        >
          <v-list-tile-avatar
            color="grey lighten-3"
            v-if="interested.avatar"
          >
            <v-img :src="interested.avatar"/>
          </v-list-tile-avatar>
          <v-list-tile-avatar
            color="grey lighten-3"
            v-else
          >
            {{ acronym(interested.name) }}
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-tooltip top>
              <div slot="activator">
                <v-list-tile-title>{{ shortName(interested.name) }}</v-list-tile-title>
                <v-list-tile-sub-title
                  class="grey--text"
                  v-if="isUser(interested)"
                >
                  {{ interested.role_name }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title
                  class="grey--text"
                  v-if="isCitizen(interested)"
                >
                  {{ formatString('xxx.xxx.xxx-xx', interested.cpf) }}
                </v-list-tile-sub-title>
              </div>
              <span v-if="isUser(interested)">
                Colaborador / {{ interested.administrative_unit_name }}
              </span>
              <span v-if="isCitizen(interested)">
                Cliente
              </span>

            </v-tooltip>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-menu
              left
            >
              <v-btn
                slot="activator"
                icon
                ripple
                :loading="loading"
              >
                <v-tooltip top>
                  <v-icon slot="activator">mdi-delete-outline</v-icon>
                  <span>Remover interessado</span>
                </v-tooltip>
              </v-btn>

              <v-card>
                <v-card-title primary-title>
                  <div>
                    <div>
                      Remover colaborador
                      <strong>{{ shortName(interested.name) }}</strong>
                    </div>
                    <span>da lista de interessados?</span>
                  </div>
                </v-card-title>

                <v-card-actions>
                  <v-layout justify-space-around>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        color="error"
                        flat
                      >
                        <v-icon>mdi-cancel</v-icon>
                      </v-btn>
                      <span>Não</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        color="success"
                        @click="removeInterested(interested)"
                        flat
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                      <span>Sim</span>
                    </v-tooltip>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-list-tile-action>
        </v-list-tile>
      </v-card>
    </v-flex>

  </v-layout>
</template>

<script>
  import formatString from 'format-string-by-pattern';
  import acronym from '@/utils/acronym';
  import shortName from '@/utils/short-name';

  import eventBus from '@/utils/event-bus';

  export default {
    name: 'InterestedCardList',
    props: ['interesteds'],
    mounted() {
      eventBus.$on('stopLoadingRemoveInterested', () => {
        this.loading = false;
      })
    },
    data() {
      return {
        shortName,
        formatString,
        loading: false,
      };
    },
    methods: {
      acronym(string) {
        return acronym(string);
      },
      removeInterested(interested) {
        this.loading = true;
        this.$emit('removeItem', interested.interested_id);
      },
      isUser({ type }) {
        return type === 'User'
      },
      isCitizen({ type }) {
        return type === 'Citizen'
      },
    },
  };
</script>
<style scoped lang="scss">

  .v-list__tile {
    &:hover {
      .v-list__tile__action {
        display: flex !important;
      }
    }

    .v-list__tile__action {
      display: none !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/folder/interested/list/InterestedCardList.vue